import { CheckCircle, Clock, PlayCircle } from 'react-feather';
import { type IntlShape } from 'react-intl';
import { CalibrationViewStatus } from './types';

export const CALIBRATION_STATUS_META = (
  formatMessage: IntlShape['formatMessage']
): Record<
  CalibrationViewStatus,
  {
    badgeColor: string;
    name: string;
    Icon: typeof CheckCircle;
    iconClassName: string;
    iconName: string;
  }
> => ({
  D: {
    badgeColor: 'secondary',
    name: formatMessage({
      id: 'app.views.widgets.dashboards.calibration_dashboard.list.status.draft',
      defaultMessage: 'Draft',
    }),
    Icon: Clock,
    iconClassName: 'text-muted',
    iconName: 'fe fe-clock',
  },
  L: {
    badgeColor: 'info',
    name: formatMessage({
      id: 'app.views.widgets.dashboards.calibration_dashboard.list.status.live',
      defaultMessage: 'Live – collecting responses',
    }),
    Icon: PlayCircle,
    iconClassName: 'text-info',
    iconName: 'fe fe-play-circle',
  },
  C: {
    badgeColor: 'success',
    name: formatMessage({
      id: 'app.views.widgets.dashboards.calibration_dashboard.list.status.complete',
      defaultMessage: 'Complete',
    }),
    Icon: CheckCircle,
    iconClassName: 'text-success',
    iconName: 'fe fe-check-circle',
  },
});
